/* UsoDiarioAdmin.jsx — Página /admin/uso-diario
   Visible para: admin, coordinadora_administrativa, control_vehicular.
   Octavio 18-jun-2026.
*/
import { useNavigate } from "react-router-dom";
import UsoDiarioPanel from "./UsoDiarioPanel";
import { useAuth } from "../auth/AuthContext";

export default function UsoDiarioAdmin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const volver = () => {
    if (user?.rol === "control_vehicular") navigate("/admin/control-vehicular");
    else if (user?.rol === "coordinadora_administrativa") navigate("/combustible");
    else navigate("/hub");
  };
  return (
    <div style={{ minHeight: "100vh", background: "#F8FAFC", color: "#0F172A" }}>
      <header style={{
        background: "#0F172A", color: "white", padding: "12px 20px",
        display: "flex", alignItems: "center", gap: 16,
      }}>
        <i className="fa-solid fa-clipboard-list" style={{ fontSize: 22, color: "#C9A84C" }}/>
        <div>
          <div style={{ fontWeight: 800, fontSize: 16 }} data-testid="uso-admin-titulo">
            Bitácora de uso de unidades · DMU 614
          </div>
          <div style={{ fontSize: 11, color: "#94A3B8" }}>
            Registros desde formulario público /registro-uso
          </div>
        </div>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 12, color: "#CBD5E1" }} data-testid="uso-admin-usuario">
            {user?.nombre || user?.usuario} · {user?.rol}
          </span>
          <button onClick={volver}
                  data-testid="uso-admin-volver"
                  style={{ background: "#1E293B", color: "white", border: 0, padding: "6px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer" }}>
            <i className="fa-solid fa-arrow-left mr-1"/>Volver
          </button>
          <button onClick={logout} data-testid="uso-admin-logout"
                  style={{ background: "transparent", border: "1px solid #475569", color: "#CBD5E1", padding: "6px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer" }}>
            Salir
          </button>
        </div>
      </header>

      <main style={{ padding: "20px", maxWidth: 1400, margin: "0 auto" }}>
        <UsoDiarioPanel/>
      </main>
    </div>
  );
}
